module.exports = __webpack_public_path__ + "img/body-2.9c557593.png";